import { render, staticRenderFns } from "./FooterComponentJig.vue?vue&type=template&id=3fc62fd2&scoped=true"
import script from "./FooterComponentJig.vue?vue&type=script&lang=ts"
export * from "./FooterComponentJig.vue?vue&type=script&lang=ts"
import style0 from "./FooterComponentJig.vue?vue&type=style&index=0&id=3fc62fd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc62fd2",
  null
  
)

export default component.exports